import { useState } from "react";
import { Check, Copy } from "lucide-react";

export default function CopyButton({ text, label = "Copy", testId, className = "" }) {
    const [copied, setCopied] = useState(false);

    async function onCopy() {
        try {
            await navigator.clipboard.writeText(text || "");
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (_e) {
            // Best-effort only.
        }
    }

    return (
        <button
            type="button"
            onClick={onCopy}
            data-testid={testId}
            className={[
                "inline-flex items-center gap-1 px-2 h-7 rounded-md text-[11px] text-ux-text-2 hover:text-ux-text-1 hover:bg-ux-bg-2 transition-colors border border-transparent hover:border-ux-border-1",
                className,
            ].join(" ")}
            title={copied ? "Copied" : label}
        >
            {copied ? <Check className="w-3.5 h-3.5 text-ux-success" /> : <Copy className="w-3.5 h-3.5" />}
            <span>{copied ? "Copied" : label}</span>
        </button>
    );
}
